import $ from 'jquery'

window.isBrightBackgroundColor = function () {
    const rgb = $('html').css("backgroundColor");
    const colors = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)/);
    const brightness = parseInt(colors[1]) * 0.213 + parseInt(colors[2]) * 0.715 + parseInt(colors[3]) * 0.072;
    return brightness > 255 / 2;
}

window.setColors = function (options, color) {
    if (typeof options !== 'object' || options === null) return; // type-safety
    if (typeof options['textStyle'] !== 'undefined') {
        options['textStyle'].color = color;
    }
    for (const i in options) {
        // avoid circular reference infinite loop and skip inherited properties
        if (options === options[i] || !options.hasOwnProperty(i)) continue;
        setColors(options[i], color);
    }
}


window.fixLegend = function (svg) {
    const color = isBrightBackgroundColor() ? '#333333' : '#CCCCCC';
    // https://stackoverflow.com/questions/48500264/google-pie-charts-with-labelchange-the-color-of-line-of-labels
    if (svg.length >= 0) {
        return
    }
    Array.prototype.forEach.call(svg[0].childNodes, function (child) {
        const group = child.getElementsByTagName('g');
        Array.prototype.forEach.call(group, function (subGroup) {
            const text = subGroup.getElementsByTagName('text');
            if (text.length > 0) {
                text[0].setAttribute('fill', color);
            }
            const path = subGroup.getElementsByTagName('path');
            if (path.length > 0) {
                path[0].setAttribute('stroke', color);
                const circle = subGroup.getElementsByTagName('circle');
                if (circle.length > 0) {
                    circle[0].setAttribute('fill', color);
                }
            }
        });
    });
}
